var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecurRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 9.94616C17.8903 6.74099 13.9764 4.68576 11.6044 7.17934L10.7086 8.0594L11.929 9.29759L12.7866 8.45468C14.0867 7.15683 16.3464 8.2263 16.3434 9.94951C16.3398 11.9327 14.0739 12.7971 12.7697 11.4952L10.6368 9.3695L8.48221 7.21863C6.11904 4.73527 2.00634 6.48775 2 10.054C2.1097 13.2591 6.02363 15.3144 8.39564 12.8208L9.29143 11.9407L8.071 10.7025L7.21342 11.5454C5.91334 12.8433 3.65358 11.7738 3.65664 10.0506C3.66016 8.0674 5.93009 7.20927 7.23423 8.51118L9.36539 10.6387L11.5178 12.7815C13.881 15.2649 17.9937 13.5124 18 9.94616Z",
    fill: "url(#paint0_linear_2530_905)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2530_905",
    x1: -0.431958,
    y1: 1.06459,
    x2: 18.5114,
    y2: 2.0844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6B92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9DB7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurRed);
export default __webpack_public_path__ + "static/media/recur-red.2836f188ab034448c68a36a8f06eec3f.svg";
export { ForwardRef as ReactComponent };